import { PRODUCT_LIST_PAGE_RECEIVE, PRODUCT_LIST_PAGE_ERROR, PRODUCT_LIST_CATEGORIES, PRODUCT_LIST_ALL_CATEGORIES } from "./ProductListPage.action";
import { error as errorReducer } from '../../../Reducers/Error.reducer';

const defaultState = {
    result: [], 
    categories: [],
    allCategories:[]
}
export const ProductListPageReducer = (state = defaultState, action) => {
    switch (action.type) {
        case PRODUCT_LIST_PAGE_RECEIVE:
            return {
                ...state,
                result: [...state.result, action.payload],
            }
        case PRODUCT_LIST_PAGE_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        case PRODUCT_LIST_CATEGORIES:
            return {
                ...state,
                categories: action.payload
            };
        case PRODUCT_LIST_ALL_CATEGORIES:
            return {
                ...state,
                allCategories: action.payload
            };
        default:
            return state;
    }
}